module.exports = "../../../../platform/assets/pageMainIcon/yewushezhilei3.svg";